// Every value in IMAGE_WIDTH_LADDER must be an Akamai IM `.auto` breakpoint (policy set
// `static_traum-ferienwohnungen_de-10883219`), else IM rounds requests up and over-serves pixels.
export const IMAGE_WIDTH_LADDER = [
    56, 80, 100, 120, 150, 160, 200, 260, 320, 400, 480, 560, 640, 720, 760, 900, 1024, 1200, 1440, 1600, 1720, 1920,
    2048,
] as const

// Applies to the on-pod next/image optimizer only; IM images use the policy's perceptualQuality.
export const IMAGE_QUALITY = 75

export const ICON_IMAGE_WIDTH = 56
export const THUMBNAIL_SM_IMAGE_WIDTH = 100
export const THUMBNAIL_MD_IMAGE_WIDTH = 150
export const THUMBNAIL_LG_IMAGE_WIDTH = 200
export const CARD_IMAGE_WIDTH = 400

export const SMALL_MOBILE_IMAGE_RESIZE_WIDTH = 320
export const MEDIUM_MOBILE_IMAGE_RESIZE_WIDTH = 480
export const LARGE_MOBILE_IMAGE_RESIZE_WIDTH = 640
export const TABLET_IMAGE_RESIZE_WIDTH = 760
export const DESKTOP_IMAGE_RESIZE_WIDTH = 1024
export const LARGE_DESKTOP_IMAGE_RESIZE_WIDTH = 1200
export const WIDE_SCREEN_IMAGE_RESIZE_WIDTH = 1600
